<div class="float-end p-1">
  <button type="button" kendoButton [disabled]="loading || selectedFunction === null || selectedFunction === undefined"
    themeColor="primary" [svgIcon]="icons.minusCircle" (click)="removeItem();">Remove Item
  </button>
  <button type="button" kendoButton themeColor="primary" [svgIcon]="icons.cancel"
    [disabled]="!stdCfgSharedServiceService.editMode || loading"
    (click)="cancelChanges();">Cancel
  </button>
  <button type="button" kendoButton themeColor="primary" [svgIcon]="icons.save"
    [disabled]="!stdCfgSharedServiceService.editMode || loading"
    (click)="saveChanges();">Save
  </button>
</div>

@if ((selectedStandardConfig !== null && selectedStandardConfig !== undefined)) {
<div class="flex-column flex-fill">
  <ag-grid-angular #agGridFF
    class="ag-theme-balham"
    style="height:100%;"
    (gridReady)="onGridReady($event)"
    [gridOptions]="gridOptions"
    [suppressMoveWhenRowDragging]="true"
    [animateRows]="true"
    [groupHideOpenParents]="false"
    [autoGroupColumnDef]="autoGroupColumnDef"
    (rowDragEnd)="onRowDragEnd($event)"
    (rowDragMove)="onRowDragMove($event)"
    (rowDragLeave)="onRowDragLeave($event)"
    (cellValueChanged)="onCellValueChanged($event)">
  </ag-grid-angular>
</div>
}